import * as React from 'react';
import company from '../company';
import LegalPage, { LegalSection } from '../components/LegalPage';

const sections: LegalSection[] = [
  {
    title: 'Aceitação dos termos',
    blocks: [
      `Ao criar uma conta, acessar uma loja ou utilizar qualquer funcionalidade da plataforma da ${company.name}, inscrita no CNPJ sob o nº ${company.cnpj} ("EasyCart", "nós"), você declara ter lido, compreendido e aceito integralmente estes Termos de Uso. Caso não concorde com alguma condição, não utilize os nossos serviços.`,
    ],
  },
  {
    title: 'Definições',
    blocks: [
      [
        {
          label: 'Plataforma',
          text: 'o aplicativo, o site e os sistemas utilizados para acesso, compra e pagamento nas lojas EasyCart.',
        },
        {
          label: 'Loja',
          text: 'o minimercado autônomo, sem operador presente, cujo acesso e pagamento são realizados pela plataforma.',
        },
        {
          label: 'Usuário',
          text: 'a pessoa física, maior de 18 anos e plenamente capaz, que se cadastra e utiliza a plataforma.',
        },
        {
          label: 'Conta',
          text: 'o cadastro individual e intransferível criado pelo usuário.',
        },
      ],
    ],
  },
  {
    title: 'Cadastro e conta',
    blocks: [
      'Para utilizar a plataforma é necessário criar uma conta com informações verdadeiras, completas e atualizadas. O usuário é o único responsável pela guarda de suas credenciais e por todas as operações realizadas com a sua conta.',
      'A conta é pessoal e intransferível. Identificado o uso de dados falsos, de terceiros ou em desacordo com estes termos, a conta poderá ser suspensa ou encerrada.',
      `Suspeitando de uso não autorizado da sua conta, comunique-nos imediatamente pelo telefone ${company.phone} ou pelo e-mail ${company.email}.`,
    ],
  },
  {
    title: 'Uso da plataforma e das lojas',
    blocks: [
      'O acesso às lojas é liberado pelo aplicativo e destina-se exclusivamente ao usuário identificado. Ao utilizar a loja, o usuário se compromete a:',
      [
        'registrar e pagar todos os produtos retirados antes de deixar o estabelecimento;',
        'não permitir a entrada de terceiros não identificados utilizando o seu acesso;',
        'zelar pela conservação dos produtos, equipamentos e instalações;',
        'não danificar, burlar ou tentar contornar os sistemas de controle, pagamento ou segurança;',
        'respeitar as regras de convivência, higiene e segurança sinalizadas no local.',
      ],
      'O descumprimento dessas regras pode acarretar o bloqueio do acesso, a cobrança dos valores devidos e a adoção das medidas civis e criminais cabíveis.',
    ],
  },
  {
    title: 'Preços, compras e pagamentos',
    blocks: [
      'Os preços são os exibidos no aplicativo e nas etiquetas da loja no momento da compra e podem ser alterados a qualquer tempo, sem aviso prévio, respeitadas as compras já concluídas.',
      'O pagamento é feito pelos meios disponibilizados na plataforma e processado por instituições financeiras e provedores de pagamento parceiros. A compra é considerada concluída após a confirmação da autorização pelo respectivo provedor.',
      'Havendo divergência de valores, produto em falta ou falha na cobrança, o usuário deve acionar nossos canais de atendimento para análise e, quando cabível, estorno ou ajuste.',
    ],
  },
  {
    title: 'Trocas, devoluções e cancelamento',
    blocks: [
      'Produtos com defeito, avariados ou fora do prazo de validade podem ser trocados ou ressarcidos, nos termos do Código de Defesa do Consumidor (Lei nº 8.078/1990). O usuário deve apresentar o comprovante da compra e acionar nossos canais de atendimento.',
      'Por se tratar de compra realizada presencialmente na loja, com verificação do produto no ato, não se aplica o direito de arrependimento previsto para compras a distância, ressalvadas as hipóteses legais de vício ou defeito do produto.',
    ],
  },
  {
    title: 'Disponibilidade e suporte',
    blocks: [
      'Empregamos os melhores esforços para manter a plataforma disponível de forma contínua, mas o serviço pode ser interrompido por manutenções programadas, falhas técnicas, indisponibilidade de rede, energia elétrica ou de serviços de terceiros. Não há garantia de funcionamento ininterrupto ou livre de erros.',
      'Podemos alterar, suspender ou descontinuar funcionalidades da plataforma a qualquer momento, buscando comunicar previamente as mudanças relevantes.',
    ],
  },
  {
    title: 'Propriedade intelectual',
    blocks: [
      `A marca ${company.name}, o aplicativo, o site, os softwares, layouts, textos, imagens e demais elementos da plataforma são de titularidade da EasyCart ou de seus licenciantes e estão protegidos pela legislação aplicável. É vedada a reprodução, distribuição, modificação, engenharia reversa ou qualquer uso não expressamente autorizado por escrito.`,
    ],
  },
  {
    title: 'Limitação de responsabilidade',
    blocks: [
      'A EasyCart responde nos limites da legislação aplicável, especialmente do Código de Defesa do Consumidor. Não nos responsabilizamos por danos decorrentes de:',
      [
        'uso indevido da conta ou compartilhamento de credenciais pelo próprio usuário;',
        'falhas de conexão, do dispositivo ou de serviços de terceiros alheios ao nosso controle;',
        'caso fortuito ou força maior;',
        'descumprimento destes Termos de Uso pelo usuário.',
      ],
    ],
  },
  {
    title: 'Privacidade e proteção de dados',
    blocks: [
      'O tratamento de dados pessoais realizado no âmbito da plataforma é descrito na nossa Política de Privacidade, que integra estes Termos de Uso e deve ser lida em conjunto com este documento.',
    ],
  },
  {
    title: 'Suspensão e encerramento',
    blocks: [
      'O usuário pode solicitar o encerramento da sua conta a qualquer momento pelos canais de atendimento, ressalvada a manutenção de dados exigida por obrigação legal.',
      'Podemos suspender ou encerrar o acesso de usuários que violarem estes termos, a legislação vigente ou que praticarem atos que comprometam a segurança das lojas, de outros usuários ou da plataforma.',
    ],
  },
  {
    title: 'Alterações destes termos',
    blocks: [
      'Estes Termos de Uso podem ser atualizados a qualquer momento. A versão vigente é sempre a publicada nesta página, com a data da última atualização indicada no topo. O uso da plataforma após a publicação de uma nova versão caracteriza a concordância com as condições atualizadas.',
    ],
  },
  {
    title: 'Lei aplicável e foro',
    blocks: [
      `Estes Termos de Uso são regidos pelas leis da República Federativa do Brasil. Fica eleito o foro da comarca do domicílio do consumidor para dirimir eventuais controvérsias, nos termos da legislação consumerista.`,
      `Dúvidas sobre estes termos podem ser encaminhadas para ${company.email} ou pelo telefone ${company.phone}.`,
    ],
  },
];

export default function TermsOfUse() {
  return (
    <LegalPage
      title="Termos de Uso"
      documentTitle={`Termos de Uso | ${company.name}`}
      intro={`Estes Termos de Uso regulam o acesso e a utilização do aplicativo, do site e das lojas autônomas da ${company.name}. Leia atentamente antes de utilizar nossos serviços.`}
      sections={sections}
    />
  );
}
